import crypto from "crypto-js";

function generateRandomString(length: number) {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  let randomString = "";

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    randomString += characters.charAt(randomIndex);
  }

  return randomString;
}

export function generateSEKAndHash() {
  const algorithm = "AES-256-CBC";
  const iv = "9MSkTNVhJcWsegS9bWJU".slice(0, 16);
  try {
    const key = crypto.lib.WordArray.random(32);

    const appkey = generateRandomString(8);

    const encrypted = crypto.AES.encrypt(appkey, key, {
      iv: crypto.enc.Utf8.parse(iv),
      mode: crypto.mode.CBC,
    });

    const encryptedHex = encrypted.ciphertext.toString();
    const keyHash = key.toString();

    return {
      hash: keyHash,
      sek: encryptedHex,
      appkey,
    };
  } catch (error) {
    console.error("", error);
    return null;
  }
}
//   const randomBytes = lib.WordArray.random(32); // Generates 128 bits (16 bytes) of random data
//   const sek = randomBytes.toString();
//   const hashedSEK = SHA256(sek).toString();
//   return { sek, hashedSEK };

//   const { sek, hashedSEK } = generateSEKAndHash();
//   console.log("SEK:", sek);
//   console.log("Hashed SEK:", hashedSEK);
//   return {
//     sek,
//     hashedSEK,
//   };
